export default __webpack_public_path__ + "static/media/no_course_logo.edd27a7a.jpg";